import { normalizeCommerceLink } from "utils/links";
import { CUSTOMER_CARE_LANDING_PAGE, CUSTOMER_CARE_TRANSACT_GUEST } from "../constants/header-account-features";
import { getRelativeURLWithParams } from "utils/url";
import { CSR_LANDING_PAGE_ROUTE } from "constants/links";
import { useEsiteCtx } from "services/esite/context";

export const useCSRFeatures = (isCatCsrUser: boolean) => {
  const { catalogId, langId, storeId } = useEsiteCtx();
  if (isCatCsrUser) {
    const customerCareFeature = {
      label: CUSTOMER_CARE_LANDING_PAGE.label,
      helperText: CUSTOMER_CARE_LANDING_PAGE.helperText,
      link: normalizeCommerceLink(
        getRelativeURLWithParams(CSR_LANDING_PAGE_ROUTE, {
          storeId,
          langId,
          catalogId,
        })
      )
    };
    const transactGuestFeature = {
      label: CUSTOMER_CARE_TRANSACT_GUEST.label,
      helperText: CUSTOMER_CARE_TRANSACT_GUEST.helperText,
      // Show dealer locator to handle the transaction as guest.
      onClick: () => void 0
    };
    return [customerCareFeature, transactGuestFeature];
  }
}